<template>
    <div class="addcase">
        <mt-header :title="title">
            <mt-button icon="back" slot="left" @click.native='goback'></mt-button>
        </mt-header>
        <div class="infobody">
            <div class="titlebox" style="padding:10px 20px;">
                <div class="line"></div>
                <h1>案例</h1>
            </div>
            <div class="casebox" v-show="workList.length>0">
                <div class="case" v-for="item in workList" :key="item.workId">
                    <div style="width:90%;">
                        <p class="title">{{item.title}}</p>
                        <p>{{item.industryName}}</p>
                    </div>
                    <div @click="$router.push('/editcase?item='+JSON.stringify(item))" style="width:10%;text-align:right">
                        <van-icon name="arrow"/>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="add" @click="$router.push('/editcase')">
                    <van-icon name="plus" />
                    <p>添加案例</p>
                </div>
            </div>
            <div class="next">
                <van-button type="info" @click="goback">上一步</van-button>
                <van-button type="info" @click="save">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
export default {
    data(){
        return{
            title:'个人信息',
            workList:[],
            accountId:'',
            accountstatus:''
        }
    },
    created(){
        this.$emit('footer', false);
        this.datainfo();
    },
    methods:{
        goback(){
            this.$router.push('/personinfo')
        },
        datainfo(){
            let _this = this
            function httpUrl () {
                return _this.axios.get('url/user/imgHttpUrl.json')
            }
            function userInfomationById () {
                return _this.axios.get('url/userName/getUserInformation?accountId='+sessionStorage.getItem('loginId'))
            }
            function loadSelect () {
                return _this.axios.get('url/account/userInfo/vueGetInfomationData')
            }
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            _this.axios.all([httpUrl(),userInfomationById(),loadSelect()])
                .then(_this.axios.spread(function (imgurl, userInfo, load) {
                    Indicator.close()
                    // 案例反显
                    if (userInfo.data.accountWorks !== undefined && userInfo.data.accountWorks.length > 0) {
                        _this.workList = userInfo.data.accountWorks
                    } else {
                        _this.workList = []
                    }
                    _this.accountId=userInfo.data.account.id
                    _this.accountstatus=userInfo.data.account.status
                })).catch(function (response) {
                    Indicator.close()
                })
        },
        save(){
            let _this =this
            if(this.workList.length<2){
                Toast({
                    message: '至少添加两个作品案例',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
            }else if(_this.accountstatus==0||_this.accountstatus==3){
                _this.axios({
                    method: "POST",
                    url: "/url/account/insertAuth",
                    data: {
                        accountId:_this.accountId,
                        status: 1,
                        createUser: _this.accountId,
                        updateUser:_this.accountId
                    },
                })
                .then(function (res) {
                    var param = {};
                    var account = new Object();
                    account.id=String(_this.accountId);
                    account.status='2';
                    account.updateUser=String(_this.accountId);
                    param.account = JSON.stringify(account);
                    var data = param;
                    if (res.data.success) {
                        _this.axios({
                            method: "POST",
                            url: "/url/account/updateAuth",
                            data: data,
                        })
                        .then(function (res) {
                            if (res.data.success) {
                                _this.$router.push('/certification')
                            } else{
                                Toast({
                                    message: res.data.msg,
                                    position: "middle",
                                    className: "indexClass",
                                    duration: 1000,
                                });
                            }
                        })
                        .catch(function (res) {
                            Toast({
                                message: "提交审核失败",
                                position: "middle",
                                className: "indexClass",
                                duration: 1000,
                            });
                        });
                    } 
                })
                .catch(function (res) {
                    Toast({
                        message: "提交审核失败",
                        position: "middle",
                        className: "indexClass",
                        duration: 1000,
                    });
                });
            }else{
                _this.$router.push('/certification')
            }
        },
    }
}
</script>

<style scoped>
    .addcase .mint-header{
        position:fixed;
        top:0;
        width:100%;
        z-index:1000;
    }
    .infobody .titlebox{
        margin-top:40px;
    }
    .infobody .titlebox .line{
        width: 8px;
        height: 12px;
        background: #6ba5e0;
        display: inline-block;
    }
    .infobody h1{
        display:inline-block;
        font-weight: bold;
        font-size:15px;
    }
    .container{
        padding:0 30px;
        margin-top: 20px;
    }
    .container .add{
        width:100%;
        border:1px solid #ddd;
        display:flex;
        align-items: center;
        justify-content: center;
        padding:10px 0;
    }
    .container .add .van-icon{
        display: inline-block;
        font-size:26px;
        color:#b0acac;
    }
    .container .add p{
        display: inline-block;
        margin-left:10px;
        vertical-align: middle;

    }
    .next{
        text-align: center;
        position: fixed;
        bottom: 0px;
        width: 100%;
        padding: 10px 0;
        background: #fff;
    }
    .next .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        color:#fff;
    }
    .casebox{
        padding:0 10px;
    }
    .casebox .case{
        background:#fff;
        padding:10px;
        box-shadow: 2px 2px 6px #888888;
        margin-top:10px;
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    .casebox .case .title{
        white-space:nowrap; 
        overflow:hidden;
        text-overflow:ellipsis;
        margin-bottom: 7px;
    }
</style>


// WEBPACK FOOTER //
// addcase.vue?ba9d946a